<div class="subcategory-description-main" *ngIf="subSelected">
  <h2 class="section-title mobile-invisible">{{ subSelected.title }}</h2>
  <div
    class="subcategory-description-itens"
    *ngFor="let sub of subSelected.sections"
  >
    <h3>{{ sub.subtitle }}</h3>
    <p>{{ sub.text }}</p>
  </div>
</div>
